import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OrganizacionesService } from '@app/_services/organizaciones.service';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AgentesService } from '@app/_services/agentes.service';
import { MenuService } from '../_services';

@Component({
  selector: 'app-agentes',
  templateUrl: './agentes.component.html',
})
export class AgentesComponent implements OnInit {

  public dataAgentes: [];
  lang;
  public seleccionados: number[] = [];
  private translate: TranslateService;
  modalReference: NgbModalRef;
  modalReferenceloading: NgbModalRef;

  constructor(
    private agentesService: AgentesService,
    private menuService: MenuService,
    public router: Router,
    translate: TranslateService,
    private translateService: TranslateService, 
    private modalService: NgbModal,
  ) { 
    this.translate = translate;
    this.agentesService.GetAll().subscribe((result) => {
      this.dataAgentes = result.data;
    })
  }

  ngOnInit(): void {
    this.lang = this.translateService.getDefaultLang();
    this.menuService.titulo = this.translate.instant('agentes.titulo');
    this.agentesService.GetAll().subscribe((result) => {
      this.dataAgentes = result.data;
      console.log('dataAgentes Loaded :'+this.dataAgentes.length.toString())
    });
  }

  onClickNuevo() {
    this.router.navigate(['agentes/crear/']);
  }

  onClickEditar() {
    if (this.seleccionados.length > 0) {
      this.router.navigate(['agentes/editar/', this.seleccionados[0]]);
    }
  }

  cellClick(e) {
    if (e.columnIndex > 0) {
      this.router.navigate(['agentes/editar/', this.seleccionados[0]]);
    }
  }

  onClickEliminar(content) {
    if (this.seleccionados.length > 0) {
      this.modalReference = this.modalService.open(content, { backdrop: 'static', size: 'lg', keyboard: false, centered: true });
    }
  }

  private eliminarRegistro(contentloading) {
    this.agentesService.delete({ codigos: this.seleccionados }).subscribe(
      (data) => {
        if (data.error == false) {
          this.agentesService.GetAll().subscribe((result) => {
            this.dataAgentes = result.data;
          }
          );
        }
        this.modalReferenceloading.close();
      }
    );
    this.modalReference.close();
    this.modalReferenceloading = this.modalService.open(contentloading, { backdrop: 'static', size: 'sm', keyboard: false, centered: true });
    this.seleccionados = [];
  }
}
